import { render, staticRenderFns } from "./IncidentDetails.vue?vue&type=template&id=4286358d&scoped=true"
import script from "./IncidentDetails.vue?vue&type=script&lang=js"
export * from "./IncidentDetails.vue?vue&type=script&lang=js"
import style0 from "./IncidentDetails.vue?vue&type=style&index=0&id=4286358d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4286358d",
  null
  
)

export default component.exports